"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.emit = void 0;
const EventsToolkitSettings_1 = require("./EventsToolkitSettings");
const EventsToolkitUtilities_1 = require("./EventsToolkitUtilities");
const _1 = require(".");
function applyDataGovernanceDefaults(eventData) {
    let page_path = null;
    let screen_size = null;
    let iframe_flag = null;
    let popup_flag = null;
    let user_agent = null;
    let url_address = null;
    let query_string = null;
    let fully_qualified_domain_name = null;
    let utm_campaign = null;
    let utm_content = null;
    let utm_medium = null;
    let utm_source = null;
    let visitor_id = null;
    let referer = null;
    if (EventsToolkitUtilities_1.isBrowser()) {
        fully_qualified_domain_name = window.location.hostname;
        url_address = window.location.href;
        page_path = window.location.pathname;
        query_string = window.location.search;
        user_agent = window.navigator.userAgent;
        var queryStringObject = EventsToolkitUtilities_1.querystringToObj(query_string);
        utm_campaign = queryStringObject.utm_campaign;
        utm_content = queryStringObject.utm_content;
        utm_medium = queryStringObject.utm_medium;
        utm_source = queryStringObject.utm_source;
        const width = window.innerWidth ||
            document.documentElement.clientWidth ||
            document.body.clientWidth;
        const height = window.innerHeight ||
            document.documentElement.clientHeight ||
            document.body.clientHeight;
        screen_size = `${width}x${height}`;
        iframe_flag = EventsToolkitUtilities_1.isInIframe();
        popup_flag = EventsToolkitUtilities_1.isInPopup();
        visitor_id = _1.visitorId;
        if (document.referrer && document.referrer != null) {
            referer = document.referrer;
        }
    }
    return Object.assign(Object.assign({}, eventData), { fully_qualified_domain_name,
        url_address,
        query_string,
        page_path,
        screen_size,
        iframe_flag,
        popup_flag,
        user_agent,
        utm_content,
        utm_medium,
        utm_source,
        utm_campaign,
        visitor_id,
        referer });
}
function emit(eventData, eventType) {
    return __awaiter(this, void 0, void 0, function* () {
        var emitStatus = true;
        var eventRequestData = undefined;
        try {
            eventRequestData = applyDataGovernanceDefaults(eventData);
            var headers = {
                "Content-Type": "application/json",
                "X-Requested-With": "XMLHttpRequest",
                Accept: "application/json",
            };
            const response = yield fetch(EventsToolkitSettings_1.settings.emit_api, {
                body: JSON.stringify({
                    properties: eventRequestData,
                    subject: eventType,
                }),
                credentials: "include",
                headers: headers,
                method: "POST",
            });
            if (response.status !== 200) {
                console.warn("Unable to emit event:", response);
                emitStatus = false;
            }
        }
        catch (error) {
            console.warn("Unable to emit event:", error);
            emitStatus = false;
        }
        return [emitStatus, eventRequestData];
    });
}
exports.emit = emit;
